<script>
import Loader from "@/components/widgets/loader.vue";
import OdemeDuzelt from './odeme_duzelt'
import { getRolename  }  from "@/helpers/helper"
import PrintMainVue from './PrintMain.vue';

export default {
  name: 'PaymentHistoryModal',
  props:[
    "data" 
  ],
  components: {
    OdemeDuzelt,
    Loader,
    PrintMainVue
  },
  data() {
    return {
      title:'',
      url:'',
      pickMabkuz:false,
      pickFatura:false,
      submitted: false,
      odemeData:{},
      subsId:0,
      loading: true,
      rows: [],
      type: 'makbuz',
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      pageLength: 0,
      columns:[
        {
          label: 'Ödemeyi Alan',
          field: 'user_name',
          sortable: false
        },
        {
          label: 'İşlem Tarih',
          field: 'created_at',
          sortable: false
        },
        {
          label: 'Ödeme Şekli',
          field: this.paymentType,
          sortable: false
        },
        {
          label: 'İşlem Açıklama',
          field: 'main_explaine',
          sortable: false
        },
        
        {
          label: 'Açıklama2',
          field: 'explaine',
          sortable: false
        },
        {
          label: 'Tahsilat',
          field: this.debt,
          sortable: false
        },
        {
          label: 'Bakiye',
          field: this.credit,
          sortable: false
        },
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        }
      ],
      totalData:{
        bakiyeToplam:0,
        satisToplam:0,
        tahsilatToplam:0,
      },
      modelOpen:0,
      checkId: []
    } 
  },
 watch:{
    data(props){
      this.title = `Ödeme Geçmişi > ${props.username}`
      this.url = `/members/${props.id}/balances`
      this.subsId = props.id
      this.loadItems() 
    }
  },
  computed:{
    rolename(){
      return getRolename()
    }
  },
  filters: {
    paymentType: function (payment_type_type,  {payment_type_title, transac_type}) {
      let odemeSekli = ''
      if(transac_type == 0){
        return 'Bayi uzattı'
      }

      if(!payment_type_type) return

      switch (payment_type_type) {
        case 'cek':
          odemeSekli = 'Çek'
          break;
        case 'kasa':
          odemeSekli = 'Nakit'
          break;
        case 'banka':
          odemeSekli = 'Kredi Kartı'
          break;
        case 'havale':
          odemeSekli = 'Havale'
          break;   
        default:
          odemeSekli = 'Veresiye'
          break;
      }
    

      return odemeSekli + ` (${payment_type_title})`
    },
    debt(obj){
        return obj.direction == 1 ? obj.amount : 0
    }, 
    credit(obj){
       return obj.direction == 2 ? obj.amount : 0
    },
  },
      
  methods: {
    isAdmin(){
      const userdata = JSON.parse(localStorage.getItem('userdata'))
      return userdata.role_name == 'admin'
    },

    debt(obj){
        return obj.direction == 1 ? obj.amount : 0
    }, 
    paymentType(obj){
      let odemeSekli = ''

      if(!obj.payment_type_type) return

      switch (obj.payment_type_type) {
        case 'cek':
          odemeSekli = 'Çek'
          break;
        case 'kasa':
          odemeSekli = 'Nakit'
          break;
        case 'banka':
          odemeSekli = 'Kredi Kartı'
          break;
        case 'havale':
          odemeSekli = 'Havale'
          break;   
        default:
          odemeSekli = 'Veresiye'
          break;
      }
      return odemeSekli + ` (${obj.payment_type_title})`
    },
    credit(obj){
        return obj.direction == 2 ? obj.amount : 0
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      
      this.loading= true
      this.getFromServer(this.serverParams).then(response => {
        this.totalData = { 
          bakiyeToplam:response.bakiyeToplam , 
          tahsilatToplam:response.tahsilatToplam , 
          satisToplam:response.satisToplam , 
        }
        this.rows = response.rows
        this.loading= false
      })
    },
    getFromServer() {
        return new Promise((resolve, reject) => {
            this.$http.post(this.url, this.serverParams)
            .then(res => {
                resolve({
                rows: res.data.data,
                bakiyeToplam: res.data.bakiyeToplam,
                satisToplam: res.data.satisToplam,
                tahsilatToplam: res.data.tahsilatToplam,
                })
            })
            .catch(error => {
                reject(error)
            })
        })
    },
    
    close(){
      this.$parent.$bvModal.hide('payment_history_modal')
    },

    print(type){
      this.modelOpen = Math.floor(Math.random() * 1000);
      this.type = type
      this.$parent.$bvModal.show('print_modal')
    },

    odemeDuzeltOpen(props){
      this.odemeData = { ...props,subscription_id:this.subsId}
      this.$parent.$bvModal.show('odeme_duzelt')
    },

    pick({target},b){
      if(b == 1 ){
        if(target.checked){
          this.pickMabkuz = true
        }else{
          this.pickMabkuz = false
        }
      }
      if(b == 2 ){
        if(target.checked){
          this.pickFatura = true
        }else{
          this.pickFatura = false
        }
      }
    }
  },
};
</script>

<template>
  <b-modal id="payment_history_modal" size="xl" :title="title"  no-close-on-backdrop hide-footer>
    <OdemeDuzelt 
      :data="odemeData" 
      @loadItems="loadItems"
    />

    <PrintMainVue 
      :data="checkId"
      :subsId="subsId"
      :modalopen="modelOpen"
      :type="type"
    />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <Loader :loading="true" :load="loading">
          <div class="row">
            <div class="col-md-12">
                <div class="text-end px-2 py-2 border border-1 bg-warning text-light">
                    Satış Toplam: {{  this.totalData.satisToplam }} |  Tahsilat Toplam: {{  this.totalData.tahsilatToplam }} |   Bakiye Toplam: {{  this.totalData.bakiyeToplam }}
                </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Fatura / Makbuz No</th>
                  <th>Ödemeyi Alan</th>
                  <th>İşlem Tarihi</th>
                  <th>Ödeme Şekli</th> 
                  <th>İşlem Açıklama</th>
                  <th>Açıklama2</th>
                  <th>Satış</th>
                  <th>Tahsilat</th>
                  <th>Bakiye</th>
                  <th v-if="isAdmin()"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,i) in rows" :key="i">       
                  <td>{{ row.invoice_num }}</td>
                  <td>{{ row.user_name }}</td>
                  <td>{{ row.created_at }}</td>
                  <td>{{ row.payment_type_type | paymentType(row) }}</td>
                  <td>{{ row.main_explaine }}</td>
                  <td>{{ row.explaine }}</td>
                  <td>{{ row | credit }}</td>
                  <td>{{ row | debt }}</td>
                  <td>{{ row.balance }}</td>
                  <td v-if="isAdmin()">
                    <button 
                      v-if="rolename == 'admin'"
                      @click="odemeDuzeltOpen(row)"
                      class="btn btn-outline-warning btn-sm">
                      Düzenle
                    </button> 
                  </td>
                  <td>
                    <input type="checkbox" :value="row.id" v-model="checkId" @change="pick($event, row.direction)">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          </Loader>
        </div>
      </div>
    </div>
      <div class="d-flex justify-content-end">
        <div>
          <button
            v-if="pickMabkuz"
            class="btn btn-primary me-2"
            @click="print('makbuz')">
              Makbuz Bas                   
            </button>
        </div>
        <div>
          <button  
            v-if="pickFatura"
            class="btn btn-primary"
            @click="print('fatura')">
            Fatura Bas                   
          </button>
       </div>
  </div>
</b-modal>
</template>